var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 17.5V19.0625C14.2857 19.5803 13.806 20 13.2143 20H1.07143C0.479688 20 0 19.5803 0 19.0625V4.6875C0 4.16973 0.479688 3.75 1.07143 3.75H4.28571V15.3125C4.28571 16.5187 5.40719 17.5 6.78571 17.5H14.2857ZM14.2857 4.0625V0H6.78571C6.19397 0 5.71429 0.419727 5.71429 0.9375V15.3125C5.71429 15.8303 6.19397 16.25 6.78571 16.25H18.9286C19.5203 16.25 20 15.8303 20 15.3125V5H15.3571C14.7679 5 14.2857 4.57812 14.2857 4.0625ZM19.6862 2.85043L16.7424 0.27457C16.5414 0.0987666 16.2689 1.29998e-06 15.9848 0L15.7143 0V3.75H20V3.51332C20 3.26469 19.8871 3.02624 19.6862 2.85043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacy-policy.c545bf5fba287beb9aee8668d0f5de3d.svg";
export { ForwardRef as ReactComponent };